export const jwtKeyName = 'staff-jwt';

export function setJwt(jwt: string) {
  return localStorage.setItem(jwtKeyName, jwt);
}
